import React from 'react';
import PropTypes from 'prop-types';
import ReleaseListItems from './ReleaseListItems';

const ReleasesList = ({ releases, setSupportNav }) => {
  const releaseListItems = releases.map(release => {
    const { id, studySource, studyType, title, meta } = release;
    return (
      <ReleaseListItems
        key={id}
        studySource={studySource}
        studyType={studyType}
        title={title.name}
        releaseDate={Number(meta.releaseDate) * 1000}
      />
    );
  });
  return (
    <div className="resources__releases">
      <div className="resources__releases--header">
        <button className="resources__releases--header--link" onClick={setSupportNav}>Contact Us​</button> for subscription inquiries
      </div>
      <div className="resources__releases--list">
        <div className="resources__releases--list-header">
          <div className="resources__releases--header--name">Release Date</div>
          <div className="resources__releases--header--name">Study</div>
        </div>
        <div className="resources__releases--list--items">
          {releaseListItems}
        </div>
      </div>
    </div>
  );
};

ReleasesList.propTypes = {
  releases: PropTypes.instanceOf(Array),
  setSupportNav: PropTypes.func,
};

export default ReleasesList;
